import { useFeatureFlag } from "@src/hooks/useFeatureFlag";

const usePublishUpdatedContentFeatureFlag = (): boolean => {
  const featureFlagEnabled = useFeatureFlag("publish_updated_content");
  return featureFlagEnabled;
};

export default usePublishUpdatedContentFeatureFlag;
